import { gql } from '@apollo/client';

export const GET_PRIVATE_KEY = gql`
  query privateKeys($args: PrivateKeysInput!) {
    privateKeys(args: $args) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
        totalCount
      }
      edges {
        cursor
        node {
          correlations {
            assetName
            assetId
          }
          filePath
          algorithm
          bitSize
          e
          foundPublicKey
          id
          matchHash
          effectivePermissions
          foundPublicKeyCount
          correlationsCount
          uniqueHash
          fileOffset
          algorithmType
          encapsulationKey
          decapsulationKey
          publicDsaKey
          privateDsaKey
          seed
          currentRemediation {
            privateKey {
              filePath
              matchHash
            }
            status
            description
            author
            createdAt
          }
        }
      }
    }
  }
`;

export const GET_PRIVATE_KEY_OLD = gql`
  query privateKeys($args: PrivateKeysInput!) {
    privateKeys(args: $args) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
        totalCount
      }
      edges {
        cursor
        node {
          correlations {
            assetName
            assetId
          }
          filePath
          algorithm
          bitSize
          e
          foundPublicKey
          id
          matchHash
          effectivePermissions
          foundPublicKeyCount
        }
      }
    }
  }
`;

export const PRIVATE_KEY_EXTERNAL_FILTER = gql`
  query privateKeyExternalFilters($args: PrivateKeyExternalFiltersInput!) {
    privateKeyExternalFilters(args: $args) {
      totalClassical
      totalPqc
    }
  }
`;

export const REMEDIATE_PRIVATE_KEYS = gql`
  mutation remediatePrivateKeys($args: RemediatePrivateKeysInput!) {
    remediatePrivateKeys(args: $args) {
      privateKey {
        filePath
        matchHash
      }
      status
      description
      author
      createdAt
      errorMessage
    }
  }
`;
